import { useState } from 'react';

import { Box, Stack } from '@mui/material';

import { usePaymentState } from '../../hooks/use-payment-state';
import { AddressElement } from '../AddressElement/AddressElement';
import { PaypalButton } from '../../../PaypalButton/PaypalButton';
import { useAddressElementRef } from '../AddressElement/hooks/use-address-element-ref';
import { useShowTaxCalculationFields } from '../../hooks/use-show-tax-calculation-fields';
import { PaymentMethodNotSupported } from '../PaymentMethodNotSupported/PaymentMethodNotSupported';

export function PaypalApmButton() {
  const setIsPaymentElementLoading = usePaymentState((state) => state.setIsPaymentElementLoading);
  const setIsApmLoading = usePaymentState((state) => state.setIsApmLoading);
  const [isPaypalAvailable, setIsPaypalAvailable] = useState(true);
  const [isAddressValid, setIsAddressValid] = useState(false);
  const { useTaxCalculationField, showAddressField } = useShowTaxCalculationFields();
  const { AddressElementRef } = useAddressElementRef();
  const isPaymentLoading = usePaymentState((state) => state.isPaymentLoading);

  const isBlockOverlay = (useTaxCalculationField && !isAddressValid) || isPaymentLoading;

  if (!isPaypalAvailable) {
    return <PaymentMethodNotSupported />;
  }

  return (
    <Stack spacing={2}>
      {useTaxCalculationField && (
        <AddressElement
          ref={AddressElementRef}
          zipOnly={!showAddressField}
          onValidationChange={(isValid) => setIsAddressValid(isValid)}
        />
      )}
      <Box position={'relative'}>
        {isBlockOverlay && (
          <Box
            position={'absolute'}
            onClick={() => {
              AddressElementRef.current?.validate();
            }}
            width={'100%'}
            height={'100%'}
            zIndex={999999}
          />
        )}
        <PaypalButton
          onReady={(isAvailable) => {
            setIsPaypalAvailable(isAvailable);
            setIsApmLoading(false);
            setIsPaymentElementLoading(false);
          }}
        />
      </Box>
    </Stack>
  );
}
